module.exports = __webpack_public_path__ + "static/media/digging.553a3456.png";